import { z } from 'zod'

const editCompanyFormSchema = z.object({
  nameKk: z.string().min(1, { message: 'Поле не может быть пустым' }),
  nameRu: z.string().min(1, { message: 'Поле не может быть пустым' }),
  katoId: z.uuid(),
  code: z.string(),
})

export { editCompanyFormSchema }
